var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectBannerTablet(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 736,
    height: 134,
    viewBox: "0 0 736 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M629.805 4.40966C764.673 20.9087 770.836 51.2319 644.141 87.6485C517.446 124.065 259.12 135.85 147.927 132.482C36.7348 129.115 -9.0756 104.306 1.94655 77.1044C12.9687 49.9025 77.7403 12.4544 164.428 6.05918C251.115 -0.336055 265.324 11.8129 348.758 18.8331C432.191 25.8532 494.938 -12.0896 629.805 4.40966Z",
    fill: "#EDA751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectBannerTablet);
export default __webpack_public_path__ + "static/media/ProjectBannerTablet.cf7f387db2936858453bb558d31a9369.svg";
export { ForwardRef as ReactComponent };